// extracted by mini-css-extract-plugin
module.exports = {"root":"CardHeader_root__na2uG","rightSlot":"CardHeader_rightSlot___0_Ax"};